var keyboardClickable = function keyboardClickable(e) {
  if (e.keyCode === 13 || e.keyCode === 32) {
    e.preventDefault();
    e.target.click();
    e.stopPropagation();
  }
};
export default keyboardClickable;